import React from 'react'

class ItemList extends React.Component{
  isActive() {
    if(this.props.data.id == this.props.activeList){
      'active'
    }
  }

  handleClick(e) {
    e.preventDefault()
    $.getJSON(`/${this.props.controller_path}/${this.props.data.id}/fetch_details`, (data) => {
      if (data.statutory_substitutions_options) {
        gon.company_variables = {...gon.company_variables, ...data.statutory_substitutions_options}
      }
      this.props.handleOnClick(this.props.data, data.description)
    })
  }

  render() {
    return(
      <li className={this.isActive()}>
        <a href="" onClick={this.handleClick.bind(this)}> {this.props.data.title} </a>
      </li>
    )
  }    
}

export default ItemList